import React, { createContext, useContext, useState, ReactNode } from 'react';

type SystemMode = 'autopilot' | 'co-flight';

interface AppContextType {
    systemMode: SystemMode;
    tokens: number;
    setSystemMode: (mode: SystemMode) => void;
    spendTokens: (amount: number) => void;
    addTokens: (amount: number) => void;
}

const AppContext = createContext<AppContextType | undefined>(undefined);

export const AppProvider = ({ children }: { children: ReactNode }) => {
    const [systemMode, setSystemMode] = useState<SystemMode>('co-flight');
    const [tokens, setTokens] = useState(1000);

    const spendTokens = (amount: number) => {
        setTokens((prev) => Math.max(0, prev - amount));
    };

    const addTokens = (amount: number) => {
        setTokens((prev) => prev + amount);
    };

    return (
        <AppContext.Provider value={{ systemMode, tokens, setSystemMode, spendTokens, addTokens }}>
            {children}
        </AppContext.Provider>
    );
};

export const useAppContext = () => {
    const context = useContext(AppContext);
    if (context === undefined) {
        throw new Error('useAppContext must be used within an AppProvider');
    }
    return context;
};
